module.exports = __webpack_public_path__ + "static/media/icn-send-active.0a29d69a.svg";